export const projects = [
  {
    projectId: "cafe-bulla",
    detail: {
      client: "Café Bulla",
      architect: "STGM",
      category: "Restaurant",
      size: "650 SQ. FT.",
      location: "Montreal, Quebec",
      date: "2023",
      status: "Completed",
    },
    about: "Bulla Café is a cozy and vibrant café located in Montreal's Plateau-Mont-Royal neighborhood at 4141 Rue Saint-Denis. Founded by a couple of Argentinians, the café uniquely blends specialty coffee culture with a love for visual arts, creating a warm and creative space that celebrates both Latin American and local Montreal artists.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg",
      "11.jpg",
      "12.jpg",
      "13.jpg",
      "14.jpg",
      "15.jpg"
    ]
  },
  {
    projectId: "cafe-collab",
    detail: {
      client: "Café Collab",
      architect: "Ivy Studio",
      category: "Restaurant",
      size: "2,000 sq. ft.",
      location: "Montreal, Quebec",
      date: "2023",
      status: "Completed",
    },
    about: "Café Collab is a coffee shop and co-working space located at 2000 Boulevard Monk in Montreal's Ville-Émard neighborhood. The establishment occupies a 2,000 square foot (approximately 185 square meters) space, offering both high-quality coffee and a collaborative environment for work and meetings.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg"
    ]
  },
  {
    projectId: "chalet-wentworth",
    detail: {
      client: "Eliova Chalet Wentworth",
      architect: "Adrein Sorin",
      category: "Residential",
      size: "1,250 SQ. FT.",
      location: " Wentworth, Quebec",
      date: "2024",
      status: "Completed",
    },
    about: "A beautifully crafted 1,250-square-foot cottage blending clean modern design with the warmth and comfort of a cozy retreat. The exterior features sleek lines, large windows, and natural materials such as wood and stone that harmonize with the surrounding landscape. Inside, the open-concept layout maximizes space and light, with high ceilings, minimalist finishes, and custom built-ins offering both function and style." +
      "\n" +
      "Smart, efficient, and elegantly understated—this cottage offers the perfect blend of modern living and timeless comfort.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg",
      "11.jpg",
      "12.jpg",
      "13.jpg",
      "14.jpg",
    ]
  },
  {
    projectId: "cncpts-adidas",
    detail: {
      client: "Adidas US - Concepts",
      architect: "Sid Lee",
      category: "Retail",
      size: "1,200 SQ. FT.",
      location: "Boston, Massachusetts",
      date: "2017",
      status: "Completed",
      award: "GRANDS PRIX DU DESIGN 2017 CATEGORIE PRIX"
    },
    about: "The ADIDAS x Concepts collaboration in Boston is a creative fusion between the global sportswear giant Adidas and the renowned Boston-based streetwear and sneaker boutique Concepts. Known for their bold, story-driven designs and cultural relevance, Concepts has a history of partnering with major footwear brands to produce limited-edition releases that celebrate local heritage, global style, and artistic expression.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg"
    ]
  },
  {
    projectId: "cncpts-boston-hq",
    detail: {
      client: "Amazon - Concepts Boston HQ",
      architect: "Sid Lee",
      category: "Retail",
      size: "3,600 SQ. FT.",
      location: "Boston, Massachusetts",
      date: "2020",
      status: "Completed"
    },
    about: "The Boston flagship offers more than just retail; it's an experiential space featuring a curated selection of footwear, apparel, and accessories from both iconic and emerging designers. The store includes an in-house café, providing a unique environment for customers to relax and socialize.",
    images: [
      "1.avif",
      "2.avif",
      "3.avif",
      "4.avif",
      "5.avif",
      "6.avif",
      "7.webp",
      "8.webp",
      "9.webp",
      "10.webp",
      "11.webp",
      "12.webp",
      "12.webp",
      "14.webp",
    ]
  },
  {
    projectId: "cncpts-miami",
    detail: {
      client: "Zappos - Concepts",
      architect: "Alex Dimas",
      category: "Retail",
      size: "10,000 SQ. FT.",
      location: "Miami, Florida",
      date: "2024",
      status: "Completed"
    },
    about: "The space features a fusion of raw industrial elements and polished finishes. Materials like high-shine marble, exposed concrete, and lush greenery create a dynamic environment that reflects both CNCPTS' streetwear roots and Miami’s vibrant aesthetic. Custom furnishings and interactive displays guide visitors through thoughtfully curated zones, enhancing the shopping experience.",
    images: [
      "1.webp",
      "2.webp",
      "3.webp",
      "4.avif",
      "5.jfif",
      "6.avif",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg",
      "11.jpg",
      "12.jpg",
      "12.jpg",
      "14.jpg",
      "15.jpg",
    ]
  },
  {
    projectId: "cncpts-new-york",
    detail: {
      client: "Amazon - Concepts New York",
      architect: "Sid Lee",
      category: "Retail",
      size: "1,400 SQ. FT.",
      location: "NYC, New York",
      date: "2021",
      status: "Completed"
    },
    about: "Located at 99 University Place in the Union Square neighborhood, CNCPTS New York represents the brand’s forward-thinking ethos. The store is more than just a retail space—it's a carefully curated environment that blends fashion, art, and street culture. The 2,500-square-foot location features a modular layout designed to host rotating brand activations, limited-edition releases, and immersive customer experiences.",
    images: [
      "1.avif",
      "2.avif",
      "3.avif",
      "4.avif",
      "5.avif",
      "6.avif",
      "7.avif",
      "8.avif",
      "9.avif",
      "10.avif",
    ]
  },
  {
    projectId: "les-chocolats-de-chloe",
    detail: {
      client: "Les Chocolats de Chloe ",
      architect: "ADHOC",
      category: "Commercial",
      size: "650 SQ. FT.",
      location: "Montreal, Quebec",
      date: "2024",
      status: "Completed",
    },
    about: "Les Chocolats de Chloé is an artisanal chocolate shop located in the heart of Plateau-Mont-Royal, Montreal. It’s known for its high-quality handcrafted chocolates and warm, inviting atmosphere.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg",
      "11.jpg",
      "12.jpg",
      "13.jpg",
      "14.jpg",
      "15.jpg",
      "16.jpg",
      "17.jpg",
      "18.jpg",
      "19.jpg",
      "20.jpg"
    ]
  },
  {
    projectId: "micro-home-chalet",
    detail: {
      client: "Eliova MicroHome Prefab",
      architect: "Adrien Sorin",
      category: "Residential",
      retail_Space: "Custom Prefab",
      location: "Montreal, Quebec",
      date: "2025",
      status: "Completed",
    },
    about: "Meant to be nestled deep within a serene forest, this 464-square-foot prefab microhome is the embodiment of cozy living and minimalist design. Inside, the space is thoughtfully designed for comfort and efficiency. An open-concept living area features natural wood finishes, soft ambient lighting, and a central wood-burning fireplace that radiates warmth and charm throughout the home. Whether it’s the flicker of flames on a chilly evening or the gentle crackle of burning logs, the fireplace brings a heartwarming sense of tranquility.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
    ]
  },
  {
    projectId: "monotoni",
    detail: {
      client: "Monotoni",
      architect: "Sid Lee",
      category: "Commercial",
      size: "1,500 sq. ft.",
      location: "Laval, Quebec",
      date: "2024",
      status: "Completed",
    },
    about: "The innovative new headquarters of Groupe Montoni, located in the heart of Laval's Espace Montmorency development. Designed by Sid Lee Architecture, reimagines the modern workplace as a dynamic, interconnected environment that fosters collaboration, wellness, and sustainability.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg",
      "11.jpg",
      "12.jpg",
      "13.jpg",
      "14.jpg",
      "15.jpg"
    ]
  },
  {
    projectId: "musee-manger",
    detail: {
      client: "Musée de la Santé",
      architect: "Rumker",
      category: "Commercial",
      size: "1,200 sq. ft.",
      location: "Laval, Quebec",
      date: "2023",
      status: "Completed",
    },
    about: "The \"Manger! L'exposition qui nourrit\" is an engaging, eco-designed exhibition at the Musée de la santé Armand-Frappier in Laval, Quebec. Conceived by the museum's scientific team in collaboration with urban nutritionist Bernard Lavallée, this exhibit offers a friendly, non-prescriptive exploration of food and nutrition.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
    ]
  },
  {
    projectId: "theatre-du-rideau-vert",
    detail: {
      client: "Theatre Du Rideau Vert",
      architect: "Sid Lee",
      category: "Commercial",
      retail_Space: "N.A",
      location: "Montreal, Quebec",
      date: "2022",
      status: "Completed",
    },
    about: "The Théâtre du Rideau Vert, located at 4664 Saint-Denis Street in Montreal's Plateau Mont-Royal district, is renowned for its striking exterior lighting that enhances its architectural presence." +
      "\n" +
      "The lighting design was crafted by Sid Lee Architecture, aiming to establish a strong architectural gesture that underscores the theatre's renewed programming and its connection to the street life of Montreal. This thoughtful integration of lighting and design elements ensures that the Théâtre du Rideau Vert remains a visually captivating landmark, both during the day and at night ",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
      "7.jpg",
      "8.jpg",
      "9.jpg",
      "10.jpg",
      "11.jpg",
      "12.jpg"
    ]
  },
    {
    projectId: "le-toasteur",
    detail: {
      client: "Le Toasteur",
      architect: "Rumker",
      category: "Restaurant",
      retail_Space: " 650 sq. ft.",
      location: "Montreal, Quebec",
      date: "2025",
      status: "Completed",
    },
    about: "Le Toasteur is a beloved breakfast and brunch spot, known for its friendly, neighborhood feel. It is cozy and casual. The space has been refreshed, including a second floor that gives an “indoor terrace” vibe — making it welcoming year-round.",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.jpg",
    ]
  },
];
